import React from 'react';

const CategorySkeleton = () => {
  return (
    <div className="rounded-2xl shadow-lg overflow-hidden">
      <div className="p-6">
        {/* Grid skeleton - simulating 6 category cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array(6).fill('').map((item) => (
            <div
              key={item}
              className="relative p-6 rounded-lg shadow-lg animate-pulse"
            >
              {/* Category title skeleton */}
              <div className="h-6 bg-gray-200 rounded mb-3 w-3/4"></div>

              {/* Created date skeleton */}
              <div className="flex items-center gap-2 mb-4">
                <div className="h-4 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
              </div>

              {/* Action buttons skeleton */}
              <div className="absolute top-3 right-3 flex gap-2">
                <div className="w-8 h-8 bg-gray-200 rounded"></div>
                <div className="w-8 h-8 bg-gray-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategorySkeleton;